
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/panels/rightPanels/openedRightPanels/rightPanels.scss.css.virtualfile';
        module.exports = {"right-panels":"_right-panels_1l8vd_7","rightPanels":"_right-panels_1l8vd_7"};